export default __webpack_public_path__ + "static/media/Gravecrypt Wristbands.ac6bfc59.jpg";